export function validateBreakCandleType(data) {
  const { candleDuration, candleType, candleColor } = data;
  if (candleDuration <= 0 || !Number.isInteger(candleDuration))
    return [false, 'Candle Duration must be a whole number larger than zero.'];
  if (!candleType || candleType === '')
    return [false, 'You must select a Candle Type.'];
  if (!candleColor || candleColor === '')
    return [false, 'You must select a Candle Color.'];
  return [true, ''];
}
